<template lang='pug'>
    div
        ElectricalPDSensorSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")
            div.title-container
                    h1.title ZM
                    h2.notopmargin Measurement Impedance for Partial Discharge Measurement according to IEC 60270

            div.margin-bottom
                .column-container
                    .column.center-content
                        img( src='@/assets/photos/ZM_1000.png', width="80%", alt='Partial Discharge Measurment Impedance BSS ZM-10', title='Partial Discharge Measurment Impedance BSS ZM-10')
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Standard Partial Discharge Measurement Impedance according to IEC 60270
                                li For Partial Discharge Measurement with a coupling capacitor
                                li Available with 1 - 30 &#x00B5;F secondary capacitance
                                li Available with BNC or 4mm connectors
                        .bluebox
                            Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt TEV-CP.pdf")
                            Maillink(to='support@bss-hs.de', sub='ZM', text='Contact Us', size=30, strokeWidth=2)
                            Sitelink(to="/en/products/PDM-600", text='Partial Discharge Monitoring System PDM-600')
                            Sitelink(to="/en/products/pdm-80", text='Partial Discharge Monitoring System PDM-80')
                            Sitelink(to="/en/products/PDM-600-Mobile", text='PDM-600-Mobile')

            div.margin-bottom
                p Measurement Impdance (Quadropole) with internal etc..


        div.fullwidth(v-if="$route.params.lang == 'de'")
            div.title-container
                h1.title ZM
                h2.notopmargin Ankoppelvierpol für die Teilentladungsmessung nach IEC 60270

            div.margin-bottom
                .column-container
                    .column.center-content
                        img( src='@/assets/photos/ZM_1000.png', width="80%", alt='Ankoppelvierpol für Teilentladungsmessungen ZM', title='Ankoppelvierpol für Teilentladungsmessungen ZM')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Für die Teilentladungsmessung nach IEC 60270
                                li Für die Benutzung mit einer externen Kopplungskapazität
                                li Erhältlich mit 1 - 30 &#x00B5;F sekundärer Kapazität
                                li Erhältlich mit BNC- oder 4mm-Anschlüssen
                        .bluebox
                            Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt TEV-CP.pdf")
                            Maillink(to='support@bss-hs.de', sub='TEV-CP', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/PDM-600", text='Partial Discharge Monitoring System PDM-600')
                            Sitelink(to="/de/products/pdm-80", text='Partial Discharge Monitoring System PDM-80')
                            Sitelink(to="/de/products/PDM-600-Mobile", text='PDM-600-Mobile')
                        
            div.margin-bottom
                p Ankoppelvierpol (Quadropol)... 
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | ZM",
            description: "Ankoppelvierpol für die Teilentladungs(TE)-Messung",
        },
        en: {
            title: "BSS | ZM",
            description:
                "PD Coupling device (PD Sensor) for Partial Discharge Measurements",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>